<template>
    <div class="item base-shadow" @click="goLink(item)">
        <div v-if="item.detail.new === 'y'" class="new">
            NEW
        </div>
        <div class="name">{{ item.detail.name }}</div>
        <div class="desc">{{ item.detail.desc }}</div>
        <div class="cart">
            <img
                src="https://oss.cloud.custouch.com/res/218365/icon-apply@3x.png"
                alt=""
                @click.stop="goSample"
            />
        </div>
    </div>
</template>
<script>
export default {
    props: ['item'],
    methods: {
        async goLink(item){
            if(item.detail.link){
                window.location.href = item.detail.link
            }
        },
        goSample(){
            this.$store.commit('setSearchKey', this.item.detail.name)
            this.$router.push({ name: 'sampleSearch' })
        }
    }
}
</script>
<style lang="less" scoped>
@import '~@/assets/style/mixin.less';
.item {
    background: @white;
    border-radius: @border-radius-sm + @border-radius-md;
    padding: @spacing @padding-sm @padding-sm @spacing / 2;
    color: @green;
    position: relative;
    .name {
        margin-bottom: 0.3rem;
    }
    .desc {
        .ellipsis(false, 2);
        font-size: @font-size-sm;
        margin-bottom: @padding-sm;
    }
    .cart {
        display: flex;
        justify-content: flex-end;
        img {
            height: 0.8rem;
            object-fit: contain;
        }
    }
    .new {
        font-size: @spacing;
        line-height: @line-height-lg;
        padding: @padding-base 0.7rem;
        transform: scale(0.5);
        transform-origin: right top;
        background: #00a6eb;
        color: @white;
        position: absolute;
        right: 0;
        top: 0;
        border-radius: 0 @border-radius-md * 3;
    }
}
</style>
